import type React from 'react'
import type { JSX } from 'react'
import type { TextBoxColors } from 'atoms/TextBox'
import type { ContainerHeaderPaddings } from './ContainerHeader.h'

import {
  ContainerHeaderAlignItems,
  ContainerHeaderColumnGap,
  ContainerHeaderDirection,
  ContainerHeaderJustifyContent,
  ContainerHeaderRowGap,
} from './ContainerHeader.h'
import { ContainerHeaderSC } from './ContainerHeader.styled'

export interface IContainerHeaderProps {
  children: React.ReactNode
  width?: number
  direction?: ContainerHeaderDirection
  justifyContent?: ContainerHeaderJustifyContent
  alignItems?: ContainerHeaderAlignItems
  rowGap?: ContainerHeaderRowGap
  columnGap?: ContainerHeaderColumnGap
  paddings?: (typeof ContainerHeaderPaddings)[keyof typeof ContainerHeaderPaddings]
  color?: TextBoxColors
}

export const ContainerHeader = ({
  children,
  width,
  direction = ContainerHeaderDirection.Row,
  justifyContent = ContainerHeaderJustifyContent.FlexStart,
  alignItems = ContainerHeaderAlignItems.FlexStart,
  rowGap = ContainerHeaderRowGap.INDENT_10,
  columnGap = ContainerHeaderColumnGap.INDENT_40,
  paddings,
  color,
}: IContainerHeaderProps): JSX.Element => (
  <ContainerHeaderSC
    width={width}
    direction={direction}
    justifyContent={justifyContent}
    alignItems={alignItems}
    rowGap={rowGap}
    paddings={paddings}
    columnGap={columnGap}
    colorDefault={color}
  >
    {children}
  </ContainerHeaderSC>
)
